var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"page-caption"},[_c('h2',[_vm._v(_vm._s(_vm.title))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }